"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderConstruction = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const UnderConstruction = ({ title }) => (react_1.default.createElement("div", { className: styles_scss_1.default.underConstruction },
    react_1.default.createElement("img", { src: constants_1.Images.undrawCoWorkers, alt: "under-construction" }),
    react_1.default.createElement("h3", null, title),
    react_1.default.createElement(components_1.HelperText, null, constants_1.default.general.underConstructionDescription)));
exports.UnderConstruction = UnderConstruction;
exports.default = exports.UnderConstruction;
